var TIPOS_VALIDOS = ['livro', 'produto', 'filme', 'youtube', 'meditacao'];

// Parser CSV que respeita campos entre aspas
function parseCSVLine(line) {
  var campos = [];
  var atual = '';
  var inQuote = false;

  for (var i = 0; i < line.length; i++) {
    var ch = line[i];
    if (ch === '"') {
      if (inQuote && line[i + 1] === '"') {
        atual += '"';
        i++;
      } else {
        inQuote = !inQuote;
      }
    } else if (ch === ',' && !inQuote) {
      campos.push(atual.trim());
      atual = '';
    } else {
      atual += ch;
    }
  }
  campos.push(atual.trim());
  return campos;
}

function limpar(str) {
  return (str || '').replace(/^"|"$/g, '').trim();
}

function extrairYoutubeId(link) {
  if (!link) return null;
  var match = link.match(/(?:v=|youtu\.be\/|embed\/)([A-Za-z0-9_-]{11})/);
  return match ? match[1] : null;
}

// Busca todos os itens da planilha unificada
// Schema: titulo | tipo | nota | imagem | link | colecao | nivel | destaque
// Retorna { itens: [...], config: { subtitulo: '...' } }
// Linhas config: tipo="config", titulo="chave", nota="valor"
export async function buscarRecomendacoes(csvUrl) {
  try {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeoutId = controller ? setTimeout(function() { controller.abort(); }, 8000) : null;
    var res = await fetch(csvUrl, { cache: 'no-store', signal: controller ? controller.signal : undefined });
    if (timeoutId) clearTimeout(timeoutId);
    if (!res.ok) throw new Error('fetch failed: ' + res.status);
    var csv = await res.text();
    var linhas = csv.split(/\r?\n/).filter(function(l) { return l.trim(); });

    var config = {};
    var itens = [];

    linhas.slice(1).forEach(function(linha) {
      var p = parseCSVLine(linha);
      var tipo = limpar(p[1]).toLowerCase();

      // Linhas de configuração (tipo="config")
      if (tipo === 'config') {
        var chave = limpar(p[0]).toLowerCase();
        var valor = limpar(p[2]); // campo "nota" usado como valor
        if (chave && valor) config[chave] = valor;
        return;
      }

      var link = limpar(p[4]);
      var imagem = limpar(p[3]);
      var youtubeId = (tipo === 'meditacao' || tipo === 'filme' || tipo === 'youtube')
        ? extrairYoutubeId(link)
        : null;

      // Para meditação: thumbnail automática do YouTube se não tiver imagem
      if (tipo === 'meditacao' && !imagem && youtubeId) {
        imagem = 'https://img.youtube.com/vi/' + youtubeId + '/mqdefault.jpg';
      }

      var item = {
        titulo:    limpar(p[0]),
        tipo:      tipo,
        nota:      limpar(p[2]),
        imagem:    imagem,
        link:      link,
        colecao:   limpar(p[5]),
        nivel:     limpar(p[6]),
        destaque:  limpar(p[7]).toLowerCase() === 'sim',
        youtubeId: youtubeId,
      };

      if (item.titulo &&
          item.titulo.length < 120 &&
          TIPOS_VALIDOS.indexOf(item.tipo) !== -1) {
        itens.push(item);
      }
    });

    return { itens: itens, config: config };
  } catch (err) {
    console.error('[Recomendacoes] erro ao buscar:', err);
    return { itens: [], config: {} };
  }
}

// Agrupa itens por coleção, mantendo a ordem de aparição na planilha
export function agruparPorColecao(itens) {
  var colecoes = [];
  var visto = {};

  itens.forEach(function(item) {
    if (!item.colecao) return;
    if (!visto[item.colecao]) {
      visto[item.colecao] = true;
      colecoes.push({
        nome: item.colecao,
        itens: itens.filter(function(i) { return i.colecao === item.colecao; }),
      });
    }
  });

  return colecoes;
}

// ── Ordem aleatória diária ───────────────────────────────────────────────────

function gerarSeedDiario() {
  var d = new Date();
  return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
}

function shuffleComSeed(arr, seed) {
  var a = arr.slice();
  var s = seed;
  for (var i = a.length - 1; i > 0; i--) {
    s = (s * 1664525 + 1013904223) % 4294967296;
    if (s < 0) s += 4294967296;
    var j = s % (i + 1);
    var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
  }
  return a;
}

export function agruparEEmbaralhar(itens) {
  var seed = gerarSeedDiario();
  var colecoes = agruparPorColecao(itens);
  return shuffleComSeed(colecoes, seed).map(function(col) {
    return { nome: col.nome, itens: shuffleComSeed(col.itens, seed + col.nome.length) };
  });
}

export function agruparComFallbackEmbaralhar(itens, labelFallback) {
  var seed = gerarSeedDiario();
  var comColecao = agruparPorColecao(itens);
  var embaralhadas = shuffleComSeed(comColecao, seed).map(function(col) {
    return { nome: col.nome, itens: shuffleComSeed(col.itens, seed + col.nome.length) };
  });
  var semColecao = itens.filter(function(i) { return !i.colecao; });
  if (semColecao.length > 0) {
    embaralhadas = embaralhadas.concat([{
      nome: labelFallback,
      itens: shuffleComSeed(semColecao, seed),
    }]);
  }
  return embaralhadas;
}
